import { RootState } from "../../app/store";
import { Base64 } from "js-base64";
import { WeaveTrainerState } from "./weaveTrainerSlice";
import { Weave } from "../../models/weave";
import { BitStream } from "bit-buffer";

class WeaveShareUtil
{
  encode = (state: RootState): string => {
    const trainer = state.weaveTrainer;
    const maxIdNum = trainer.weaves.reduce((a, b) => Math.max(a, b.idNum), 0);
    const stream = new BitStream(new ArrayBuffer(256));
    
    stream.writeUint8(1); //Version 1
    stream.writeUint8(trainer.intl);
    stream.writeUint8(trainer.rank);
    for (let i = 1; i <= maxIdNum; i++) {
      const weave = trainer.weaves.find(x => x.idNum === i && x.percentTarget);
      stream.writeBoolean(!!weave);
      if (weave) {
        stream.writeUint8(weave.percentTarget);
      }
    }
    
    const view = new Uint8Array(stream.buffer, 0, stream.byteIndex);
    return Base64.fromUint8Array(view, true);
  }

  decode = (data: string) => {
    const trainer = { weaves: [] as Weave[] } as WeaveTrainerState;
    const view = Base64.toUint8Array(data);
    const stream = new BitStream(view.buffer);

    const version = stream.readUint8();
    if (version === 1) {
      trainer.intl = stream.readUint8();
      trainer.rank = stream.readUint8();
      for (let i = 1; stream.bitsLeft; i++) {
        if (stream.readBoolean()) {
          const weave = {} as Weave;
          weave.idNum = i;
          weave.percentTarget = stream.readUint8();
          trainer.weaves.push(weave);
        }
      }
    }

    return trainer;
  }
}

export const weaveShareUtil = new WeaveShareUtil();
